var datePicker = {
  options: {
  },

  selectors: {
    repertoir_date_range: '.js-datepicker-repertoir-date-range',
  },

  init: function () {
    const self = this;

    self.initDatePickers();
  },

  initDatePickers: function () {
    const self = this;

		//Date range picker in Repertoir
		jQuery(self.selectors.repertoir_date_range).daterangepicker({
      minDate: moment(), //now
      autoApply: true,
      autoUpdateInput: false,
      locale: {
        format: 'DD.MM.YYYY',
        daysOfWeek: sikmoVars.translation.list_days_of_week,
      }
    });
		
    // Set input empty initially
    jQuery(self.selectors.repertoir_date_range).val('');

    // Fill input only when user selects a date
    jQuery(self.selectors.repertoir_date_range).on('apply.daterangepicker', function(ev, picker) {
      jQuery(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY'));
			jQuery(this).trigger('input'); // Trigger input event to update filters
    });
  },
}

export { datePicker };